import React, { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';

import Copy from 'Src/components/Copy';
import FontIcon from 'Src/components/icons/FontIcon';
import { Check } from 'Src/feature/check/models';

import { EditGiftCardModal } from './EditGiftCardModal';
import { GiftCard } from './giftCardService';

import styles from './CheckPanelGiftCards.module.scss';

const TEST_ID = {
  root: 'CheckPanelGiftCards',
};

interface CheckPanelGiftCardsProps {
  check: Check | undefined;
  canEdit: boolean;
}

const CheckPanelGiftCards: FC<CheckPanelGiftCardsProps> = ({ check, canEdit }) => {
  const { t } = useTranslation();
  const [selectedGiftCard, setSelectedGiftCard] = useState(undefined as undefined | GiftCard);

  if (!check?.giftCards.length) return;

  const onClick = (giftCard: Check['giftCards'][number]) => {
    if (!canEdit) return;
    setSelectedGiftCard(giftCard);
  };

  return (
    <>
      <div data-testid={TEST_ID.root} className={styles.root}>
        {check?.giftCards.map((gc) => {
          if (gc.status !== 'Added' && gc.status !== 'Issued') return;
          return (
            // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
            <div key={gc.id} className={styles.item} onClick={() => onClick(gc)}>
              <FontIcon className={styles.icon} name="payment" size="sm" />
              <div className={styles.grid}>
                <Copy
                  variant="body"
                  weight="semi-bold"
                  value={t('payment.labels.giftCardInfo', { maskedAccount: gc.account.replace(/.(?=.{4})/g, '*') })}
                />
                <Copy
                  variant="body"
                  weight="semi-bold"
                  type="currency"
                  value={gc.amount}
                />
              </div>
            </div>
          );
        })}
      </div>
      {
        canEdit && (
          <EditGiftCardModal
            key={selectedGiftCard?.id}
            open={!!selectedGiftCard}
            onClose={() => setSelectedGiftCard(undefined)}
            giftCard={selectedGiftCard}
            checkId={check?.id}
          />
        )
      }
    </>
  );
};

export { CheckPanelGiftCards, TEST_ID };
